module.exports = __webpack_public_path__ + "static/media/signin2.c278f860.svg";